// Camera wit sticker

import { useState } from 'react';
import Webcam from "react-webcam";
import { translate } from '../functions/translationHelper';


function ContentColorFilter(props) {
  

  const [error, setError] = useState(false);

  const [colorindex, setColorindex] = useState(0);


  return (
    <div className="page-content-camera">

      {error &&
        <div className='cameraerrormessage'>
          {translate("camera_permission_denied", props.language)}
        </div>
      }

      {
        props.content?.colors?.length > 1 && 
        <div className='colorfilter-toggle'>
          {
            props.content?.colors.map((e,i) => <div className={`colorfilter-toggle-button ${colorindex == i ? "colorfilter-toggle-button-active" : ""}`} style={{backgroundColor: e}} onClick={() => setColorindex(i)}></div>)
          }
        </div>
      }

      <div className="colorfilter" style={{backgroundColor: props.content?.colors?.[colorindex] ?? "ff0000"}}></div>

      {props.active &&
        <Webcam
          audio={false}
          videoConstraints={{ facingMode: "environment" }}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          onUserMediaError={() => setError(true)}
        />
      }
    </div>
  );
}

export default ContentColorFilter;
